import { render, staticRenderFns } from "./Equity.vue?vue&type=template&id=228eece2&scoped=true&"
import script from "./Equity.vue?vue&type=script&lang=js&"
export * from "./Equity.vue?vue&type=script&lang=js&"
import style0 from "./Equity.vue?vue&type=style&index=0&id=228eece2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228eece2",
  null
  
)

export default component.exports